import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class SessionMgmtService {
  constructor(public _utilsService: UtilsService) {}

  public setData(key: string, value: string) {
    if (environment.secureSessionStorage.enable) {
      localStorage.setItem(key, this.encrypt(value));
    } else {
      localStorage.setItem(key, value);
    }
  }

  public getData(key: string) {
    const data = localStorage.getItem(key) || '';
    if (data) {
      if (environment.secureSessionStorage.enable) {
        const decryptValue = this.decrypt(data);
        if (typeof decryptValue === 'string') {
          return this.decrypt(data);
        } else {
          return JSON.parse(this.decrypt(data));
        }
      } else {
        if (typeof data === 'string') {
          return data;
        } else {
          return JSON.parse(data);
        }
      }
    } else {
      return false;
    }
  }

  public removeData(key: string) {
    localStorage.removeItem(key);
  }

  public clearData() {
    localStorage.clear();
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(
      txt,
      environment.secureSessionStorage.key
    ).toString();
  }

  private decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(
      txtToDecrypt,
      environment.secureSessionStorage.key
    ).toString(CryptoJS.enc.Utf8);
  }
}
